<!--隐私协议-->
<template>
    <div class="select-view">
        <div class="select-search">
            <form action="/">
                <van-search
                    v-model="value"
                    show-action
                    left-icon=""
                    placeholder="请输入门店ID"
                    @search="onSearch"
                >
                    <template #action>
                        <div @click="onSearch"><van-icon name="search" color="#000" size="20"/></div>
                    </template>
                </van-search>
            </form>
        </div>

    </div>
</template>

<script>

import ayzAjax from "@/plugins/axios";
import {showFailToast} from "vant";

export default {
    name: "SelectView",
    data: function () {
        return {
            value:'',
        }
    },
    created() {

    },
    methods: {
        onSearch(){
            ayzAjax.get('/get_station?station_id=' + this.value).then((response) => {
                console.log(response.data);
                if(response.data.code !== 200){
                    return showFailToast(response.data.msg);
                }
                localStorage.setItem('station', JSON.stringify(response.data.data));
                this.$router.push({ path: '/call/apply' });
            })
        },
    }
}
</script>

<style lang="scss" scoped>

.select-view{
    width: 100%;
    .select-search{
        margin: 10px;
        background: #FFF;
        border: #F6F6F6 1px solid;
        //border-radius: 25px;
        border-radius: 15px;
    }
    //margin-top: 10px;
}
</style>
